import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TOP_BANNER_HEIGHT } from '@layout';

export const WrapperBox = styled(Box)`
  position: relative;
  background: linear-gradient(180deg, #fff3e8 0%, rgba(249, 245, 240, 0) 100%);
`;

export const MobileWrapperBox = styled(Box)`
  position: relative;
  margin-top: calc(${themeSpace(11)} + ${TOP_BANNER_HEIGHT}px);
  @media screen and (min-width: 36rem) {
    padding-top: calc(${themeSpace(16)} + ${TOP_BANNER_HEIGHT}px);
  }
`;

export const StyledBox = styled(Box)`
  text-align: center;
`;

export const ContentBox = styled(Box)`
  z-index: 3;
  margin: auto;
  max-width: 470px;
  ${themeMediaQuery('xl')} {
    max-width: 544px;
  }
`;

export const AssetsWrapperBox = styled(Box)`
  display: flex;
  justify-content: center;
`;

export const AssetsBox = styled(Box)`
  position: relative;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

export const ForgroundAssetsBox = styled(AssetsBox)`
  top: 260px;
  position: absolute;
`;

export const ForgroundCloudImage = styled(CloudImage)<{
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
  circle?: string;
  zindex?: string;
}>`
  height: auto;
  position: absolute;
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  top: ${({ top }) => top};
  bottom: ${({ bottom }) => bottom};
  border-radius: ${({ circle }) => (circle ? '50%' : '0')};
  z-index: ${({ zindex }) => (zindex ? '-1' : '1')};
`;

export const MobileTopCloudImage = styled(CloudImage)`
  position: absolute;
  height: auto;
  z-index: -1;
  top: 0;
  left: 0;
`;

export const MobileCloudImage = styled(CloudImage)`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

export const MobileWaveTagCloudImage = styled(MobileCloudImage)`
  margin-top: ${themeSpace(7)};
  margin-bottom: ${themeSpace(7)};
`;

export const MobilePicCloudImage = styled(MobileCloudImage)`
  width: 80%;
  border-radius: 4px;
`;

export const MobileArtCloudImage = styled(MobileCloudImage)`
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: -1;
  @media screen and (min-width: 36rem) {
    bottom: -25vw;
  }
  ${themeMediaQuery('sm')} {
    bottom: 0;
  }
`;
